import * as Backbone from 'backbone';

// This component can NOT go within a custom-select.
// There's a focus event that will close this component, making thee events useless.
class MultiSelectSearch extends Backbone.View {
	get events() {
		return ({
			'click .sma-multi-select-menu': 'clickedContainer',
			'click .sma-multi-select-done': 'clickedDone',
			'change .sma-multi-select-dropdown .sma-checkbox-input': 'checkboxChanged',
			'input .sma-multi-select-search': 'onSearchInput'
		});
	}

	updateDropdownText(component) {
		let checkedLabels = $(component).find('.sma-checkbox-input:checked').next();
		let dropdownButton = $(component).find('.sma-multi-select-dropdown-button');

		let dropdownButtonText = gettext('Select...');
		if (checkedLabels.length == 1) {
			dropdownButtonText = checkedLabels.first().text();
		} else if (checkedLabels.length > 1) {
			dropdownButtonText = interpolate(
				ngettext('%(label)s  (+%(num)s item)', '%(label)s  (+%(num)s items)', checkedLabels.length - 1), {
					label: checkedLabels.first().text(),
					num: checkedLabels.length - 1
				}, true);

			let titleText = checkedLabels.map(function () {
				return $(this).text();
			}).get().join(', ');

			dropdownButton.attr('title', titleText);
		}

		dropdownButton.text(dropdownButtonText);
	}

	initialize(config) {
		this.setElement($('body'));

		$('.sma-multi-select-dropdown').each((i, component) => {
			this.updateDropdownText(component);
		});
	}

	clickedContainer(e) {
		e.stopPropagation();
	}

	clickedDone(e) {
		$(e.currentTarget).dropdown('toggle');
	}

	checkboxChanged(e) {
		const count = $(e.currentTarget).closest('.sma-multi-select-menu').find('input:checked').length;
		const minCount = $(e.currentTarget).closest('.sma-multi-select-menu').data('min_count');
		if (minCount && count < minCount) {
			$(e.currentTarget).prop('checked', true);
			return;
		}
		$(e.currentTarget).closest('.sma-multi-select-container')
			.find('.sma-multi-select-selected-count').text(count);

		this.updateDropdownText($(e.currentTarget).closest('.sma-multi-select-dropdown'));

		e.stopPropagation();
	}

	onSearchInput(e) {
		let checkboxes = $(e.currentTarget).closest('.sma-multi-select-menu').find('.sma-multi-select-row');
		let searchTerm = $(e.currentTarget).closest('.sma-multi-select-menu').find('.sma-multi-select-search').val().toLowerCase();

		checkboxes.each((i, checkbox) => {
			if ($(checkbox).find('label').text().toLowerCase().includes(searchTerm)) {
				$(checkbox).show();
			} else {
				$(checkbox).hide();
			}
		});
	}
}

module.exports = {
	MultiSelectSearch,
};
